import React, { useState, useEffect } from "react";
import { withRouter, Redirect } from "react-router-dom";
import MiniDrawer from "./../MiniDrawer";
import { IonButton } from '@ionic/react';
import { AgGridReact } from "ag-grid-react";

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

import "./Page.css";
import "./../App.css";

import { getTimestamp } from "../components/timeStamp.js";
import { govHeadersJson } from "../services/hmrcGovHeaders.js";

import { useRecoilState } from "recoil";
import { advisorAtom } from "../atom.js";
import { getLocalStorage } from "../components/localstorage.js";

const MTDAuths = (props) => {
  const [advisor_atom, setAdvisorAtom] = useRecoilState(advisorAtom);
  const [recoilFetched, setRecoilFetched] = useState(false);
  const [authRequestsData, setAuthRequestsData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [logout, setLogout] = useState(false);

  // Grid configuration
  const constants = {
    defaultColDef: {
      resizable: true,
      editable: false,
      sortable: true,
      filter: true,
      floatingFilter: true,
      suppressMenu: true,
      flex: 1,
      minWidth: 100,
      suppressMovable: true,
    },
    columnDefs: [
      {
        headerName: "Invitation ID",
        field: "invitationId",
        cellClass: "cell-style",
        filter: true,
        width: 150,
      },
      {
        headerName: "Nino",
        field: "nin",
        cellClass: "cell-style",
        filter: true,
        width: 120,
      },
      {
        headerName: "ARN",
        field: "arn",
        cellClass: "cell-style",
        filter: true,
        width: 120,
      },
      {
        headerName: "Service",
        field: "service",
        cellClass: "cell-style",
        filter: true,
        width: 100,
      },
      {
        headerName: "Status",
        field: "status",
        cellClass: "cell-style",
        filter: true,
        width: 120,
        cellRenderer: (params) => {
          const status = params.value;
          let color = '#6c757d'; // default gray
          if (status === 'Accepted') {
            color = '#28a745'; // green
          } else if (status === 'Cancelled') {
            color = '#dc3545'; // red
          } else if (status === 'Pending') {
            color = '#ffc107'; // yellow
          }
          return `<span style="color: ${color}; font-weight: bold;">${status}</span>`;
        }
      },
      {
        headerName: "Agent Type",
        field: "agentType",
        cellClass: "cell-style",
        filter: true,
        width: 120,
      },
      {
        headerName: "Created",
        field: "created",
        cellClass: "cell-style",
        filter: true,
        width: 180,
        valueFormatter: (params) => {
          if (params.value) {
            return new Date(params.value).toLocaleString();
          }
          return '';
        }
      },
      {
        headerName: "Updated",
        field: "updated",
        cellClass: "cell-style",
        filter: true,
        width: 180,
        valueFormatter: (params) => {
          if (params.value) {
            return new Date(params.value).toLocaleString();
          }
          return '';
        }
      }
    ],
  };

  useEffect(() => {
    if (!recoilFetched) {
      let userState = getLocalStorage();
      if (!userState.agentToken) {
        setLogout(true);
      } else {
        if (localStorage.getItem("pingTime")) {
          let lastEvent = localStorage.getItem("pingTime");
          const nowTime = new Date();
          const thenTime = Date.parse(lastEvent);
          const dif = nowTime - thenTime;
          const secondsElapsed = dif / 1000;

          if (secondsElapsed > 2700) {
            setLogout(true);
          } else {
            if (userState.agentToken) {
              setAdvisorAtom(userState);
              getAuthRequests(userState.agentToken);
              setRecoilFetched(true);
            } else {
              setLogout(true);
            }
          }
        } else {
          setLogout(true);
        }
      }
    }
  }, [recoilFetched]);

  const getAuthRequests = (token = advisor_atom.agentToken) => {
    console.log('Fetching MTD auth requests...');
    
    fetch(`https://${global.api_url}/hmrc/listAgentAuthRequests.php?ts=${getTimestamp()}`, {
      method: "GET",
      headers: { 
        token: token, 
        agentId: advisor_atom.agent || "default",
        govHeaders: govHeadersJson()
      }
    })
      .then(res => res.json())
      .then(json => {
        console.log('MTD Auth Requests Response:', json);
        
        if (json.status === 200 && json.result) {
          // Parse the result string as JSON
          const parsedData = JSON.parse(json.result);
          console.log('Parsed auth requests data:', parsedData);
          
          // Transform the data to match our grid columns
          const transformedData = parsedData.map(item => {
            // Extract invitation ID from the self link
            const invitationId = item._links?.self?.href?.split('/').pop() || 'N/A';

            return {
              invitationId: invitationId,
              nin: item.nin || 'Not found',
              arn: item.arn,
              service: item.service ? item.service.join(', ') : 'N/A',
              status: item.status,
              agentType: item.agentType,
              created: item.created,
              updated: item.updated
            };
          });
          
          console.log('Transformed data for grid:', transformedData);
          setAuthRequestsData(transformedData);
          
          if (gridApi) {
            gridApi.redrawRows();
          }
        } else {
          console.error('Error fetching auth requests:', json);
          setLogout(true);
        }
      })
      .catch(error => {
        console.error('Network error fetching auth requests:', error);
      });
  };

  const services = {
    gridService: {
      onGridReady: (params) => {
        setGridApi(params.api);
        params.api.sizeColumnsToFit();
      },
    },
    renderService: {
      displayMainScreen: () => {
        if (logout) {
          localStorage.clear();
          return (
            <Redirect
              to={{
                pathname: "/logout",
              }}
            />
          );
        }

        if (recoilFetched) {
          return (
            <>
              <div
                style={{
                  height: 48,
                  flexDirection: "row",
                  display: "flex",
                  paddingLeft: 0,
                  paddingBottom: 7
                }}
              >
                <h2 style={{ margin: "10px 20px 0 0" }}>MTD Authorization Requests (Last 30 Days)</h2>
                <IonButton
                  className="ion-button-money"
                  style={{ "--box-shadow": "none" }}
                  onClick={() => {
                    getAuthRequests();
                  }}
                >
                  Refresh Auth Requests
                </IonButton>
              </div>
              
              <div className={`ag-theme-alpine grid-container show-grid`}>
                <AgGridReact
                  defaultColDef={constants.defaultColDef}
                  rowData={authRequestsData}
                  columnDefs={constants.columnDefs}
                  animateRows
                  rowHeight={30}
                  rowSelection={"multiple"}
                  pagination={false}
                  rowDeselection={true}
                  suppressRowClickSelection={true}
                  suppressDragLeaveHidesColumns={true}
                  onGridReady={services.gridService.onGridReady}
                />
              </div>
            </>
          );
        }
      },
    },
  };

  return (
    <React.Fragment>
      <div className="accounts-page-container">
        <MiniDrawer code={advisor_atom.agent_code} />
        <div className="accounts-page-content">
          {services.renderService.displayMainScreen()}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(MTDAuths);
